// extracted by mini-css-extract-plugin
export default {"container":"List_container__GAgLq","note":"List_note__R1pc1","text":"List_text__8yAkO","meta":"List_meta__fWS76","btn":"List_btn__Vy1-2"};